import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { PLAN_CATEGORY } from '../planCategory';
import { useStyles } from './categoryToggle.styles';

// Pill-shaped segmented control switching the dialog between its two plan pages.
function CategoryToggle ({ value, onChange, businessLabel, communityLabel }) {
    const classes = useStyles();

    const options = [
        { category: PLAN_CATEGORY.BUSINESS, label: businessLabel },
        { category: PLAN_CATEGORY.COMMUNITY, label: communityLabel },
    ];

    return (
        <div className={classes.group} role='tablist' aria-label='Plan categories'>
            {options.map((option) => {
                const selected = value === option.category;
                return (
                    <button
                        key={option.category}
                        type='button'
                        role='tab'
                        aria-selected={selected}
                        className={classnames(classes.option, { [classes.optionActive]: selected })}
                        onClick={() => onChange(option.category)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}

CategoryToggle.propTypes = {
    value: PropTypes.oneOf([PLAN_CATEGORY.BUSINESS, PLAN_CATEGORY.COMMUNITY]).isRequired,
    onChange: PropTypes.func.isRequired,
    businessLabel: PropTypes.string,
    communityLabel: PropTypes.string,
};

CategoryToggle.defaultProps = {
    businessLabel: 'BUSINESS & ENTERPRISE',
    communityLabel: 'COMMUNITY',
};

export default CategoryToggle;
